<div class="app-homepage">
    <div class="section-1">
        <div class="background">
            <!-- <video #videoPlayerHeader class="video" muted loop playsinline autoplay preload="auto"
                style="pointer-events: none; display: block;">
                <source src="https://assets.credible.finance/HologramM.mp4" type="video/mp4">
            </video> -->
            <div class="top-section">
                <div class="title">
                    <span>The Decentralized AI Credit Layer.</span>
                </div>
            </div>

            <div class="top-2-section">
                <div class="left-side">
                    <div class="subtitle">Credible connects stablecoin lenders to asset backed credit opportunities in
                        emerging markets by tokenizing securitized loan portfolios from licensed credit institutions.
                    </div>
                    <div class="button-section">
                        <cf-button label="Deposit USDC" type="theme" (clicked)="gotoURL('/lend')"></cf-button>
                    </div>
                </div>

                <div class="right-side">
                    <div class="stat-field">
                        <span class="stat-value">12%</span>
                        <span class="stat-heading">APY on stablecoins</span>
                        <span class="stat-heading-mobile">APY on stablecoins</span>
                    </div>
                    <div class="stat-field">
                        <span class="stat-value">${{ stats.tvl_usd | number:'0.0-0'}}</span>
                        <span class="stat-heading">Loans originated</span>
                        <span class="stat-heading-mobile">Loans originated</span>
                    </div>
                </div>
            </div>

            <!-- <div class="arrow-section">
                <img class="arrow-img" src="https://assets.credible.finance/DownArrow1.gif" />
            </div> -->
        </div>
    </div>

    <div class="backers-partners-section" id="ecosystem">
        <div class="title">Backers and Partners</div>
        <div class="box-container">
            <div class="box partnets_img" *ngFor="let item of partners_array; let i = index">
                <a [href]="item.redirection_url">
                    <img class="img" [src]="item.img_url" [alt]="'Image ' + (i + 1)" />
                </a>
            </div>
        </div>
    </div>



    <div class="section-ai-infrastructure">
        <div class="our-solution">
            <div class="content">
                <div class="left-section">
                    <div class="left-section-heading">Genesis - AI-Powered Credit Infrastructure
                    </div>
                    <div class="left-section-description">
                        Genesis is your gateway to owning a node license in Credible’s decentralized credit ecosystem.
                        Power the future of lending with CreditAI agents for underwriting and scoring, and a ZK oracle
                        node that enables real-time monitoring, predictive alerts, and privacy-preserving access to
                        credit data.
                    </div>
                    <!-- <div class="bullet-points">
                        <div class="bullet-point">
                            <i class="fa-regular fa-circle-check"></i>
                            <span>Lorem ipsum dolor sit amet</span>
                        </div>

                        <div class="bullet-point">
                            <i class="fa-regular fa-circle-check"></i>
                            <span>Lorem ipsum dolor sit amet consectetur. Elit in.</span>
                        </div>
                    </div> -->

                    <div class="controls gap-2">
                        <cf-button label="Buy Genesis"
                            (clicked)="gotoURL('https://genesis.credible.finance/')"></cf-button>
                    </div>
                </div>
                <div class="right-section">
                    <video #videoPlayer width="70%" muted loop playsinline autoplay preload="auto"
                        style="pointer-events: none; display: block;">
                        <source src="https://assets.credible.finance/ai.mp4" type="video/mp4">
                        Your browser does not support the video tag.
                    </video>
                </div>
            </div>
        </div>
    </div>

    <div class="section-5">
        <div class="heading">Secure & Transparent</div>
        <div class="content">
            <div class="protocol-security-card">
                <div class="heading">Protocol Security</div>
                <div class="description">All our smart contracts are audited by Sec3. All are institutional borroweres
                    are rated by Credora</div>
                <div class="image">
                    <div class="image-holder">
                        <img src="https://assets.credible.finance/Credoralogo.png" alt="Credora" title="Credora"
                            loading="lazy" />
                        <span class="image-label">Credora rated</span>
                    </div>
                    <div class="image-holder">
                        <img src="https://assets.credible.finance/Sec3.png" alt="Sec3" title="Sec3" loading="lazy" />
                        <span class="image-label">Sec3 Audited</span>
                    </div>
                </div>
            </div>

            <div class="transactions-card">
                <div class="heading">Transparent</div>
                <div class="description">All transactions are on-chain publicly tracked</div>
                <div class="transactions">
                    <div class="transaction" *ngFor="let transaction of transactions"
                        (click)="httpService.redirectionTx(transaction.blockchain, transaction.chain, transaction.network, transaction.blockchain_txid)">
                        <div class="transaction-line-1">
                            <div class="transaction-amount">+{{ transaction.amount | number : "0.0-2" }} {{
                                transaction.currency | uppercase }}</div>
                            <div class="transaction-txid">{{ transaction.blockchain_txid }}</div>
                        </div>
                        <div class="transaction-line-2">
                            <div class="transaction-usd-value">
                                <span class="dollar-sign">$</span>
                                {{ transaction.amount_usd | number:'0.0-2' }}
                            </div>
                            <div class="transaction-date">{{ transaction.created | date : 'mediumDate' }}</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="section-4">
        <div class="our-solution">
            <div class="content">
                <div class="left-section">
                    <!-- <div class="left-section-sub-heading">Business Solutions</div> -->
                    <div class="left-section-heading">
                        Credit Identity, Credit Card &
                        <br />Stablecoin Banking for Web3 Users
                    </div>
                    <div class="left-section-description">
                        An AI-powered credit score based on your onchain reputation gives you access to real credit
                        cards and stablecoin banking.
                    </div>

                    <!-- <div class="bullet-points">
                        <div class="bullet-point">
                            <i class="fa-regular fa-circle-check"></i>
                            <span>Credit assessed & rated borrowers</span>
                        </div>

                        <div class="bullet-point">
                            <i class="fa-regular fa-circle-check"></i>
                            <span>Fintechs, NBFIs and real world applications as borrowers</span>
                        </div>

                        <div class="bullet-point">
                            <i class="fa-regular fa-circle-check"></i>
                            <span>Short term opportunities, max 3-months lockup</span>
                        </div>
                    </div> -->

                    <div class="controls">
                        <cf-button label="Get Started" type="theme"
                            (clicked)="gotoURL('https://genesis.credible.finance/')"></cf-button>
                    </div>
                </div>

                <div class="right-section">
                    <img src="https://assets.credible.finance/Mobile+image+(1).png" alt="Credible" title=""
                        loading="lazy" />
                </div>
            </div>
        </div>

        <div class="borrow">
            <div class="content">
                <div class="right-section">
                    <img src="https://assets.credible.finance/Lending+Pool+screen.png" alt="Credible" title=""
                        loading="lazy" />
                </div>
                <div class="left-section">
                    <!-- <div class="left-section-sub-heading">Retail Solutions</div> -->
                    <div class="left-section-heading">Regulated lenders adopt the <br />Credible Score and Raise Debt
                    </div>
                    <div class="left-section-description">
                        The Credible Score represents an onchain credit identity. Regulated lenders can use it for
                        underwriting, and qualified institutions can also set up lending pools on Credible to raise and
                        deploy capital.
                    </div>

                    <!-- <div class="bullet-points">
                        <div class="bullet-point">
                            <i class="fa-regular fa-circle-check"></i>
                            <span>Licensed NBFIs & VASPs</span>
                        </div>

                        <div class="bullet-point">
                            <i class="fa-regular fa-circle-check"></i>
                            <span>Fiat loans for healthcare & trade finance</span>
                        </div>

                        <div class="bullet-point">
                            <i class="fa-regular fa-circle-check"></i>
                            <span>Fiat loans for crypto collateral</span>
                        </div>
                    </div> -->

                    <div class="controls">
                        <cf-button label="Get Started" type="theme" (clicked)="redirectToLend()"></cf-button>
                    </div>
                </div>

            </div>
        </div>

        <!-- <div class="controls">
            <cf-button label="Learn more" type="theme"
                (clicked)="redirectToInternalUrl('https://credible.gitbook.io/docs/introduction/payfi')"></cf-button>
        </div> -->
    </div>



    <!-- <div class="section-6">
        <div class="heading">Ecosystem</div>
        <div class="description">A fintech powered by DeFi</div>

        <div class="ecosystem-image">
            <img src="https://assets.credible.finance/EcosystemImage.png" alt="Ecosystem" title="Ecosystem"
                loading="lazy" />
        </div>
    </div> -->

    <!-- <div class="section-7">
        <div class="our-solution">
            <div class="content">
                <div class="left-section">
                    <div class="left-section-sub-heading">Fintech</div>
                    <div class="left-section-heading">Consumer & SME Finance</div>
                    <div class="left-section-description">
                        In partnership with NBFIs in India and UAE, we are offering healthcare consumer loans and SME
                        trade finance loans.
                    </div>

                    <div class="controls">
                        <cf-button label="Coming soon" type="theme"></cf-button>
                    </div>

                    <div class="animated-image">
                        <img src="https://assets.credible.finance/Image55.png" alt="Apply Now" title="Apply Now"
                            loading="lazy" />
                    </div>

                    <div class="mobile-apps">
                        <img src="https://assets.credible.finance/image31.png" alt="Play store" title="Play store"
                            loading="lazy" />

                        <img src="https://assets.credible.finance/image41.png" alt="App store" title="App store"
                            loading="lazy" />
                    </div>
                </div>
                <div class="right-section">
                    <img src="https://assets.credible.finance/FintechImage.png" alt="Mobile app" title="Mobile app"
                        loading="lazy" />
                </div>
            </div>
        </div>
    </div> -->

    <div class="section-8">
        <div class="row">
            <div class="col-12 col-sm-12 col-md-3 col-lg-3 col-xl-3">
                <div class="logo" [routerLink]="'/'">
                    <img src="https://assets.credible.finance/CredibleWhitelogo1.png" alt="Credible Finance"
                        title="Credible Finance" loading="lazy" (click)="scrollUp()" />
                </div>

                <div class="community">
                    <a href="https://twitter.com/crediblefin" target="_blank">
                        <i class="fa-brands fa-twitter"></i>
                    </a>
                    <a href="https://t.me/crediblefinance" target="_blank">
                        <i class="fa-brands fa-telegram"></i>
                    </a>
                    <a href="https://medium.com/@credible_finance" target="_blank">
                        <i class="fa-brands fa-medium"></i>
                    </a>
                    <a href="https://discord.com/invite/DjKy6PaJTb" target="_blank">
                        <i class="fa-brands fa-discord"></i>
                    </a>
                </div>
            </div>

            <div class="col-12 col-sm-12 col-md-9 col-lg-9 col-xl-9">
                <div class="row">
                    <div class="col-md-2">
                        <div class="d-grid">
                            <span class="links-heading">Product</span>
                            <span class="links-label" routerLink="/lend">Private Credit</span>
                            <span class="links-label" routerLink="/cash-loan">PayFi</span>
                        </div>
                    </div>

                    <div class="col-md-2">
                        <div class="d-grid">
                            <span class="links-heading">Community</span>
                            <a href="mailto:help@credible.finance" target="_blank" class="links-label">Support</a>
                            <a href="https://twitter.com/crediblefin" target="_blank" class="links-label">Twitter</a>
                            <a href="https://t.me/crediblefinance" target="_blank" class="links-label">Telegram</a>
                            <a href="https://medium.com/@credible_finance" target="_blank"
                                class="links-label">Medium</a>
                            <a href="https://discord.com/invite/DjKy6PaJTb" target="_blank"
                                class="links-label">Discord</a>
                        </div>
                    </div>

                    <div class="col-md-2">
                        <div class="d-grid">
                            <span class="links-heading">Resources</span>
                            <a href="https://credible.gitbook.io/" target="_blank" class="links-label">Docs</a>
                            <!-- <a href="https://docsend.com/view/c4nm6fpy6kfk2vez" target="_blank"
                                class="links-label">Litepaper</a>
                            <span class="links-label">Developer Docs</span> -->
                        </div>
                    </div>
                    <div class="col-md-6">
                        <div class="d-grid">
                            <span class="links-heading">Legal</span>

                            <div style="    display: grid
                            ;
                                grid-template-columns: 1fr 1fr;">
                                <a (click)="redirectToUrl('/privacy-policy')" target="_blank"
                                    class="links-label">Privacy
                                    Policy</a>
                                <a (click)="redirectToUrl('/terms-condition')" target="_blank" class="links-label">Terms
                                    And Conditions</a>
                                <a (click)="redirectToUrl('/cookies-policy')" target="_blank"
                                    class="links-label">Cookies
                                    Policy</a>
                                <a (click)="redirectToUrl('/affiliate-program-policy')" target="_blank"
                                    class="links-label">Affiliate Program
                                    Policy</a>
                                <a (click)="redirectToUrl('/risk-disclosure-policy')" target="_blank"
                                    class="links-label">Risk Disclosure
                                    Policy</a>
                                <a (click)="redirectToUrl('/loans-credit-terms-conditions')" target="_blank"
                                    class="links-label">Loans & Credit Terms and Conditions</a>
                                <a (click)="redirectToUrl('/card-provider-terms-conditions')" target="_blank"
                                    class="links-label">Card Provider Terms and Conditions</a>
                                <a (click)="redirectToUrl('/decentralized-finance-terms-conditions')" target="_blank"
                                    class="links-label">Decentralized Finance Terms And Conditions</a>
                            </div>


                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>